import React from "react";
import { motion } from "framer-motion";
import {
  ClipboardList,
  ShieldCheck,
  EyeOff,
  Factory,
  Eye,
  AppWindow,
} from "lucide-react";

const items = [
  {
    icon: ClipboardList,
    title: "Launch One Bidding Request",
    desc: "Create one procurement bidding request and let DeMaxtore organize the entire online bidding process.",
  },
  {
    icon: ShieldCheck,
    title: "Verified Manufacturers",
    desc: "Only verified Turkish manufacturers participate — identity and capacity confirmed before bidding begins.",
  },
  {
    icon: EyeOff,
    title: "Anonymous Competition",
    desc: "Manufacturers compete anonymously, ensuring fair conditions and protected commercial confidentiality.",
  },
  {
    icon: Factory,
    title: "Competitive Factory Offers",
    desc: "Manufacturers submit competitive factory offers directly during the live bidding window.",
  },
  {
    icon: Eye,
    title: "Transparent Procurement",
    desc: "Track participation, offer activity and bidding status in real time with full process visibility.",
  },
  {
    icon: AppWindow,
    title: "One Workspace",
    desc: "From bidding request to purchase order — every step continues inside a single DeMaxtore Workspace.",
  },
];

export default function WhyCommodityBid() {
  return (
    <section
      data-testid="why-commoditybid-section"
      id="why-commoditybid"
      className="relative py-24 md:py-32 bg-[#F8FAFC]"
    >
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl"
        >
          <p className="font-inter text-[11px] font-bold tracking-[0.22em] uppercase text-[#3B82F6]">
            Why CommodityBid
          </p>
          <h2 className="mt-3 font-display text-3xl md:text-[42px] font-extrabold tracking-tight text-[#0B1F3A] leading-[1.1]">
            The most professional way<br className="hidden md:block" />
            <span className="text-[#475569]">to run procurement bidding online.</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.45, delay: i * 0.06 }}
                data-testid={`why-card-${i}`}
                className="group relative rounded-[20px] bg-white border border-slate-200/80 p-7 transition-all duration-300 hover:border-[#3B82F6]/30 hover:shadow-[0_12px_40px_-8px_rgba(15,23,42,0.10)] hover:-translate-y-0.5"
              >
                <div className="h-11 w-11 rounded-xl bg-[#3B82F6]/10 text-[#3B82F6] flex items-center justify-center group-hover:bg-[#3B82F6] group-hover:text-white transition-colors">
                  <Icon className="h-5 w-5" strokeWidth={2} />
                </div>
                <h3 className="mt-5 font-display text-[17px] font-bold tracking-tight text-[#0B1F3A]">
                  {item.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-[#475569]">
                  {item.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
